import React,{useState, useEffect, useRef} from "react";
import Toast from "../../../lib/toast";

const ManagePlans = (props) => {

  var [currentElementId, setCurrentElementId] = useState("");
  const isDataUpdated = useRef(false);
  const isMobile = window.innerWidth < 768;
  const [planDetails, setPlanDetails] = useState({
    name: "",
    type: "",
    activities: "",
    planTimingType: "regular_time",
    sessionTiming: [
      {
        day : "Mon",
        selected : false
      },
      {
        day : "Tue",
        selected : false
      },
      {
        day : "Wed",
        selected : false
      },
      {
        day : "Thu",
        selected : false
      },
      {
        day : "Fri",
        selected : false
      },
      {
        day : "Sat",
        selected : false
      },
      {
        day : "Sun",
        selected : false
      }
    ],
    packages: []
  })

  const planTypes = ["GymWorkout", "PersonalTraining", "GroupEx", "LybertyMembership"];

  const planTimingType = ["Regular Timings", "Happy Hours"];

  const activities = ["Yoga", "Zumba", "Muscle Bounce", "Fit Combat", "G-Force", "Rapid Fit"];
  
  const packageDetails = {
    durationType: "Day",
    duration: "",
    session: "",
    rackRate: "",
    basePrice: "",
    upgradePlan : false,
    upgradeDurationType: "Day",
    upgradeDuration: "",
    poolMembership: false,
    poolCharges: [{
      poolMembersAllowed:1,
      percentage:null,
    },{
      poolMembersAllowed:2,
      percentage:null,
    },{
      poolMembersAllowed:3,
      percentage:null,
    },{
      poolMembersAllowed:4,
      percentage:null,
    },{
      poolMembersAllowed:5,
      percentage:null,
    }]
  };

  var [isDropdownType, setDropdownType] = useState("");

  const toggleInputFields = (id) => event => {
    if (currentElementId == id) {
      currentElementId = ''
      setCurrentElementId(currentElementId);
      isDropdownType = "";
      setDropdownType(isDropdownType);
    } else {
      currentElementId=id;
      setCurrentElementId(currentElementId)
      let element = document.getElementById(id);
      if (element) {
        element.focus();
      }
      isDropdownType = id
      setDropdownType(isDropdownType);
    }
  }
  
  const handleChange = (event, index) => {
    if(currentElementId == "plan-name"){
      setPlanDetails(prev => ({
        ...prev,
        name: event.target.value
      }));
    }

    if(currentElementId == "duration-" + index){
      setPlanDetails(prev => ({
        ...prev,
        packages: prev.packages.map((item, i) => 
          i === index ? {
            ...item,
            duration: event.target.value
          } : item
        )
      }))
    }

    if(currentElementId == "session-" + index){
      setPlanDetails(prev => ({
        ...prev,
        packages: prev.packages.map((item, i) => 
          i === index ? {
            ...item,
            session: event.target.value
          } : item
        )
      }))
    }

    if(currentElementId == "rack-rate-" + index){
      setPlanDetails(prev => ({
        ...prev,
        packages: prev.packages.map((item, i) => 
          i === index ? {
            ...item,
            rackRate: event.target.value
          } : item
        )
      }))
    }

    if(currentElementId == "base-price-" + index){
      setPlanDetails(prev => ({
        ...prev,
        packages: prev.packages.map((item, i) => 
          i === index ? {
            ...item,
            basePrice: event.target.value
          } : item
        )
      }))
    }

    if(currentElementId == "upgrade-duration-" + index){
      setPlanDetails(prev => ({
        ...prev,
        packages: prev.packages.map((item, i) => 
          i === index ? {
            ...item,
            upgradeDuration: event.target.value
          } : item
        )
      }))
    }
  }

  const handleSelectDropdownItem = (dataType, value, index) => {
    if(dataType == "plan-type"){
      setPlanDetails(prev => ({
        ...prev,
        type : value
      }));
    }

    if(dataType == "activities-list"){
      setPlanDetails(prev => ({
        ...prev,
        activities : value
      }));
    }

    if(dataType == "plan-timing"){
      setPlanDetails(prev => ({
        ...prev,
        planTimingType : value
      }));
    }

    if(dataType == "duration-type"){
      setPlanDetails(prev => ({
        ...prev,
        packages: prev.packages.map((item, i) => 
          i === index ? {
            ...item,
            durationType: value
          } : item
        )
      }))
    }

    if(dataType == "upgrade-duration-type"){
       setPlanDetails(prev => ({
        ...prev,
        packages: prev.packages.map((item, i) => 
          i === index ? {
            ...item,
            upgradeDurationType: value
          } : item
        )
      }))
    }


    setDropdownType("");
  }

  const handleSessionTime = (index) => {
    setPlanDetails(prev => ({
      ...prev,
      sessionTiming: prev.sessionTiming.map((item, i) =>  
        i === index ? {
          ...item,
          selected: !item.selected
        } : item)
    }))
  }

  const handleUpgradePlan = (index) => {
    setPlanDetails(prev => ({
      ...prev,
      packages : prev.packages.map((item, i) =>
        i === index ? {
          ...item,
          upgradePlan : item.upgradePlan?false:true
      } : item)
    }))
  }

  const handlePoolMembership = (index) => {
    setPlanDetails(prev => ({
      ...prev,
      packages: prev.packages.map((item, i) => {
        if (i !== index) return item;

        const { poolCharges, ...rest } = item;
        const turningOn = !item.poolMembership;

        return {
          ...rest,
          poolMembership: turningOn,
          ...(turningOn && {
            poolCharges: [
              { poolMembersAllowed: 1, percentage: null },
              { poolMembersAllowed: 2, percentage: null },
              { poolMembersAllowed: 3, percentage: null },
              { poolMembersAllowed: 4, percentage: null },
              { poolMembersAllowed: 5, percentage: null },
            ]
          })
        };
      })
    }));
  };
  const handleSelectMembershipPooling = (p,index,pIndex) => event => {
    setPlanDetails(prev => ({
      ...prev,
      packages: prev.packages.map((item, i) => 
        i === index ? {
          ...item,
          poolCharges: item.poolCharges.map((pc,pci) => 
            pci == pIndex ? {
              ...pc,
              percentage: event.target.value <= 100 ? event.target.value : pc.percentage
            } : pc
          )
        } : item
      )
    }))

    if(event.target.value > 100){
      new Toast({
        type:"warning",
        message:"Pool charge must be less than or equal to 100%",
        duration:3000
      })
    }
  }


  useEffect(() => {
    //prev.packages, 
    setPlanDetails(prev => ({
      ...prev,
      packages: [{...packageDetails}]
    }))
  },[])


  useEffect(()=>{
    if(props.updateMembershipData){
      props.updateMembershipData({...planDetails});
    }
  },[planDetails]);

  useEffect(()=>{
    if(props.membershipPlan && !isDataUpdated.current){
      isDataUpdated.current = true;
      setPlanDetails(oldstate=>{
        if(props.membershipPlan.activities) oldstate.activities=props.membershipPlan.activities[0];
        oldstate.packages=[];
        if(props.membershipPlan.packages && props.membershipPlan.packages.length){
          for(let p of props.membershipPlan.packages){
            let payload={
              ...packageDetails
            };

            if(p.durationType) payload.durationType = p.durationType;
            if(p.duration) payload.duration = p.duration;
            if(p.basePrice) payload.basePrice = p.basePrice;
            if(p.rackRate) payload.rackRate = p.rackRate;
            if(p.sessions) payload.session = p.sessions;
            if(p.poolMembership) payload.poolMembership = p.poolMembership;
            if(p.poolCharges) payload.poolCharges = p.poolCharges;
            payload.upgradePlan = p.isUpgradePlan?true:false;
            if(p.upgradeDurationType) payload.upgradeDurationType = p.upgradeDurationType;
            if(p.upgradeDuration) payload.upgradeDuration = p.upgradeDuration;
            oldstate.packages.push(payload);
          
          }
        }
        if(props.membershipPlan.name) oldstate.name=props.membershipPlan.name;
        if(props.membershipPlan.planTimingType) oldstate.planTimingType=props.membershipPlan.planTimingType;
        if(props.membershipPlan.type) oldstate.type=props.membershipPlan.type;
        return {...oldstate}
      })
    }
  },[props])

  return(
    <div className="w-full h-full" style={{padding:"12px", overflowY:"auto"}}>
      <div className="d-flex-wrap space-between">
        <div onClick={toggleInputFields('plan-name')} className={`${currentElementId == "plan-name" || planDetails.name ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: currentElementId == "plan-name" || planDetails.name ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 640 ? "49%" : "100%" }}>
          <div className="flex-item d-flex">
            <svg  className="flex-item m-r-6" width={currentElementId == "plan-name" || planDetails.name ? "12" : "16"}  height={currentElementId == "plan-name" || planDetails.name ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 1.07143C6.5439 1.07143 7.07558 1.22852 7.52782 1.52285C7.98005 1.81717 8.33253 2.23551 8.54067 2.72496C8.74881 3.2144 8.80327 3.75297 8.69716 4.27256C8.59105 4.79216 8.32914 5.26943 7.94454 5.64404C7.55995 6.01864 7.06995 6.27375 6.5365 6.3771C6.00305 6.48046 5.45012 6.42741 4.94762 6.22468C4.44512 6.02194 4.01563 5.67862 3.71346 5.23813C3.41128 4.79765 3.25 4.27977 3.25 3.75C3.25 3.0396 3.53973 2.35829 4.05546 1.85596C4.57118 1.35363 5.27065 1.07143 6 1.07143ZM6 0C5.23854 0 4.49418 0.219934 3.86105 0.631989C3.22793 1.04404 2.73446 1.62971 2.44306 2.31494C2.15167 3.00016 2.07542 3.75416 2.22398 4.48159C2.37253 5.20902 2.73921 5.8772 3.27764 6.40165C3.81607 6.9261 4.50208 7.28325 5.2489 7.42794C5.99573 7.57264 6.76984 7.49838 7.47333 7.21455C8.17683 6.93072 8.77812 6.45007 9.20116 5.83339C9.6242 5.2167 9.85 4.49168 9.85 3.75C9.85 2.75544 9.44438 1.80161 8.72236 1.09835C8.00035 0.395088 7.02108 0 6 0ZM11.5 15H10.4V12.3214C10.4 11.9697 10.3289 11.6214 10.1907 11.2964C10.0525 10.9714 9.84991 10.6761 9.59454 10.4274C9.33918 10.1787 9.03603 9.98136 8.70238 9.84675C8.36873 9.71214 8.01114 9.64286 7.65 9.64286H4.35C3.62065 9.64286 2.92118 9.92506 2.40546 10.4274C1.88973 10.9297 1.6 11.611 1.6 12.3214V15H0.5V12.3214C0.5 11.3269 0.905624 10.373 1.62764 9.66978C2.34965 8.96652 3.32892 8.57143 4.35 8.57143H7.65C8.67108 8.57143 9.65035 8.96652 10.3724 9.66978C11.0944 10.373 11.5 11.3269 11.5 12.3214V15Z" fill={currentElementId == "plan-name" || planDetails.name ? "var(--darkBlue)" : "#6d6d6d"}/>
            </svg>
            <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "plan-name" || planDetails.name ? "10px" : "14px", color: currentElementId == "plan-name" || planDetails.name ? "var(--darkBlue)" : "", transition: "180ms" }}>Plan Name *</p>
          </div>
          <input id="plan-name" onChange={handleChange} value={planDetails.name} placeholder="Enter Membership Plan Name" className={`${currentElementId == "plan-name" || planDetails.name ? "active-input-field" : "inactive-input-field"}`} type="text" />
        </div>
        <div onClick={toggleInputFields('plan-type')} className={`${currentElementId == 'plan-type' || planDetails.type ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == 'plan-type' || planDetails.type ? "1px solid var(--darkBlue)" : "",  width: window.innerWidth > 640 ? "49%" : "100%"}}>
          <div className='d-flex w-full space-between'>
            <div className='flex-item'>
              <div className="flex-item d-flex">
                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'plan-type' || planDetails.type ? "10px" : "", color: currentElementId == 'plan-type' || planDetails.type ? "var(--darkBlue)" : "", transition: "180ms" }}>Plan Type *</p>
              </div>
              <input readOnly value={planDetails.type} type="text" className={`${currentElementId == 'plan-type' || planDetails.type ? "active-input-field" : "inactive-input-field"}`} placeholder="Select referrer's name" />
            </div>
            <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == "plan-type" ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
              <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
              </svg>
            </div>
            {
              isDropdownType == "plan-type" && (
                <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                  {
                    planTypes.map(data=>{
                      return (
                        <div onClick={()=>handleSelectDropdownItem("plan-type", data)} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">{data}</p>
                        </div>
                      )
                    })
                  }
                </div>
              )
            }
          </div>
        </div>
      </div>

      {
        planDetails.packages.map((data,index) => {
          return(
            <div className="packages-container m-b-20">
              <div className="d-flex-wrap space-between">
                <div onClick={toggleInputFields('duration-type-' + index)} className={`${currentElementId == 'duration-type-' + index || data.durationType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} ${isMobile ? "m-b-12" : ""}`} style={{ border: currentElementId == 'duration-type-' + index || data.durationType ? "1px solid var(--darkBlue)" : "",  width: isMobile ? "48%" : "170px"}}>
                  <div className='d-flex w-full space-between'>
                    <div className='flex-item'>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'duration-type-' + index || data.durationType ? "10px" : "", color: currentElementId == 'duration-type-' + index || data.durationType ? "var(--darkBlue)" : "", transition: "180ms" }}>Duration Type *</p>
                      </div>
                      <input readOnly value={data.durationType} type="text" className={`${currentElementId == 'duration-type-' + index || data.durationType ? "active-input-field" : "inactive-input-field"}`} placeholder="Select Duration Type" />
                    </div>
                    <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == "duration-type" ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
                      <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                      </svg>
                    </div>
                    {
                      isDropdownType == "duration-type-" + index && (
                        <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                          <div onClick={()=>handleSelectDropdownItem("duration-type", "Day", index)} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Day</p>
                          </div>
                          <div onClick={()=>handleSelectDropdownItem("duration-type", "Month", index)} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Month</p>
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>
                <div onClick={toggleInputFields('duration-' + index)} className={`${currentElementId == "duration-" + index || data.duration != "" ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} ${isMobile ? "m-b-12" : "m-l-12"}`} style={{ border: currentElementId == "duration-" + index || data.duration != "" ? "1px solid var(--darkBlue)" : "", width: isMobile ? "48%" : "100px" }}>
                  <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === "duration-" + index || data.duration != "" ? "10px" : "14px", color: currentElementId == "duration-" + index || data.duration != "" ? "var(--darkBlue)" : "", transition: "180ms" }}>Duration *</p>
                  <input id={'duration-' + index} onChange={e => handleChange(e, index)} value={data.duration} placeholder="00" className={`${currentElementId == "duration-" + index || data.duration != "" ? "active-input-field" : "inactive-input-field"}`} type="number" />
                </div>
                <div onClick={toggleInputFields('session-' + index)} className={`${currentElementId == "session-" + index || data.session != "" ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} ${isMobile ? "m-b-12" : "m-l-12"}`} style={{ border: currentElementId == "session-" + index || data.session != "" ? "1px solid var(--darkBlue)" : "", width: isMobile ? "48%" : "90px" }}>
                  <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === "session-" + index || data.session != "" ? "10px" : "14px", color: currentElementId == "session-" + index || data.session != "" ? "var(--darkBlue)" : "", transition: "180ms" }}>Session *</p>
                  <input id={'session-' + index} onChange={e => handleChange(e, index)} value={data.session} placeholder="00" className={`${currentElementId == "session-" + index || data.session != "" ? "active-input-field" : "inactive-input-field"}`} type="number" />
                </div>
                <div onClick={toggleInputFields('rack-rate-' + index)} className={`${currentElementId == "rack-rate-" + index || data.rackRate != "" ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} ${isMobile ? "m-b-12" : "m-l-12"}`} style={{ border: currentElementId == "rack-rate-" + index || data.rackRate != "" ? "1px solid var(--darkBlue)" : "", width: isMobile ? "48%" : "100px" }}>
                  <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === "rack-rate-" + index || data.rackRate != "" ? "10px" : "14px", color: currentElementId == "rack-rate-" + index || data.rackRate != "" ? "var(--darkBlue)" : "", transition: "180ms" }}>Rack Rate *</p>
                  <input id={'rack-rate-' + index} onChange={e => handleChange(e, index)} value={data.rackRate} placeholder="00" className={`${currentElementId == "rack-rate-" + index || data.rackRate != "" ? "active-input-field" : "inactive-input-field"}`} type="number" />
                </div>
                <div onClick={toggleInputFields('base-price-' + index)} className={`${currentElementId == "base-price-" + index || data.basePrice != "" ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} ${isMobile ? "" : "m-l-12"}`} style={{ border: currentElementId == "base-price-" + index || data.basePrice != "" ? "1px solid var(--darkBlue)" : "", width: isMobile ? "48%" : "110px" }}>
                  <p className="placeholder-txt flex-item" style={{fontSize: currentElementId === "base-price-" + index || data.basePrice != "" ? "10px" : "14px", color: currentElementId == "base-price-" + index || data.basePrice != "" ? "var(--darkBlue)" : "", transition: "180ms" }}>Base Price *</p>
                  <input id={'base-price-' + index} onChange={e => handleChange(e, index)} value={data.basePrice} placeholder="0.0" className={`${currentElementId == "base-price-" + index || data.basePrice != "" ? "active-input-field" : "inactive-input-field"}`} type="number" />
                </div>
              </div>
              <div onClick={()=>handlePoolMembership(index)} className="d-flex m-t-20 cursor-pointer">
                {
                  data.poolMembership ? (
                    <svg className="flex-item" width="24" height="24" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                      <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                  ) : (
                    <svg className="flex-item" width="24" height="24" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0.5" y="0.5" width="14" height="14" rx="3.5" stroke="#959595"/>
                    </svg>
                  )
                }
                <p className="flex-item fs-16 font-weight-600 m-l-8">Pool Membership</p>
              </div>
              {
                data.poolMembership && (
                  <div className="d-flex-wrap">
                    {
                      data.poolCharges.map((p,pIndex) => {
                        return(
                          <div className="flex-item d-flex pooling-container m-r-12 m-t-12">
                            <p className="flex-item font-weight-600">1 + {p.poolMembersAllowed} Pooling</p>
                            <input onChange={handleSelectMembershipPooling(p, index, pIndex)} value={p.percentage != null ? p.percentage : ""} className="m-l-8 flex-item" type="number" placeholder="0.0" style={{background:"#ffffff", borderRadius:"8px", border:"1px solid #9a9a9a", width:"50px", textAlign:"center"}} />
                            <p className="color-red flex-item m-r-8 m-l-8 font-weight-700">%</p>
                          </div>
                        )
                      })
                    }
                  </div>
                )
              }
              <div onClick={()=>handleUpgradePlan(index)} className="d-flex m-t-20 cursor-pointer">
                {
                  data.upgradePlan ? (
                    <svg className="flex-item" width="24" height="24" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="15" height="15" rx="4" fill="var(--darkBlue)"/>
                      <path d="M4 7.72727L6.33333 10L11 5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                  ) : (
                    <svg className="flex-item" width="24" height="24" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0.5" y="0.5" width="14" height="14" rx="3.5" stroke="#959595"/>
                    </svg>
                  )
                }
                <p className="flex-item fs-16 font-weight-600 m-l-8">Upgrade Plan</p>
              </div>
              {
  data.upgradePlan && (
    <div className={`${isMobile ? "d-flex-wrap" : "d-flex"} m-t-8`} style={{ alignItems: "flex-start", gap: "12px" }}>
      <div onClick={toggleInputFields('upgrade-duration-type-' + index)} className={`${currentElementId == 'upgrade-duration-type-' + index || data.upgradeDurationType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == 'upgrade-duration-type-' + index || data.upgradeDurationType ? "1px solid var(--darkBlue)" : "",  width: isMobile ? "48%" : "170px"}}>
        <div className='d-flex w-full space-between'>
          <div className='flex-item'>
            <div className="flex-item d-flex">
              <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == 'upgrade-duration-type-' + index || data.upgradeDurationType ? "10px" : "", color: currentElementId == 'upgrade-duration-type-' + index || data.upgradeDurationType ? "var(--darkBlue)" : "", transition: "180ms" }}>Duration Type *</p>
            </div>
            <input readOnly value={data.upgradeDurationType} type="text" className={`${currentElementId == 'upgrade-duration-type-' + index || data.upgradeDurationType ? "active-input-field" : "inactive-input-field"}`} placeholder="Select Duration Type" />
          </div>
          <div className='input-field-arrow-dropdown' style={{ transform: isDropdownType == "upgrade-duration-type-" + index ? "rotate(180deg)" : "", margin: "12px 8px 4px 0", transition: "180ms" }}>
            <svg className="flex-item" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
            </svg>
          </div>
          {
            isDropdownType == "upgrade-duration-type-" + index && (
              <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                <div onClick={()=>handleSelectDropdownItem("upgrade-duration-type", "Day", index)} className="global-input-field-arrow-dropdown-item">
                  <p className="flex-item">Day</p>
                </div>
                {
                  props.membershipPlan.membershipPlanId && (
                    <div onClick={()=>handleSelectDropdownItem("upgrade-duration-type", "Month", index)} className="global-input-field-arrow-dropdown-item">
                      <p className="flex-item">Month</p>
                    </div>
                  )
                }
              </div>
            )
          }
        </div>
      </div>
      <div onClick={toggleInputFields("upgrade-duration-" + index)} className="member-global-input-field flex-item" style={{ border: currentElementId == "upgrade-duration-" + index || data.upgradeDuration ? "1px solid var(--darkBlue)" : "", width: isMobile ? "48%" : "90px" }}>
        <div className='d-flex w-full space-between'>
          <div className='flex-item'>
            <div className="flex-item d-flex">
              <p className="placeholder-txt flex-item" style={{ fontSize: "10px", color: currentElementId == "upgrade-duration-" + index || data.upgradeDuration ? "var(--darkBlue)" : "", transition: "180ms" }}>Duration *</p>
            </div>
            <input id={"upgrade-duration-" + index} onChange={e => handleChange(e, index)} value={data.upgradeDuration} placeholder="00" className="active-input-field" type="text" />
          </div>
        </div>
      </div>
    </div>
  )
}
            </div>
          )
        })
      }
    </div>
  )
}

export default ManagePlans;